import { gql } from '@apollo/client';

import STUDENT_SETTINGS_FRAGMENT from '../../fragments/student-setting';

const REMOVE_STUDENT_SETTING = gql`
  mutation removeStudentSettingMutation($where: StudentSettingWhereInput!) {
    removeStudentSetting(where: $where) {
      ...BaseStudentSettings
    }
  }
  ${STUDENT_SETTINGS_FRAGMENT}
`;

export default REMOVE_STUDENT_SETTING;
